export type PopupLayout = {
  left: number
  top: number
  width: number
  height: number
}

export type ResizeDirection = 'n' | 'ne' | 'e' | 'se' | 's' | 'sw' | 'w' | 'nw'

export const RESIZE_DIRECTIONS: ResizeDirection[] = [
  'n',
  'ne',
  'e',
  'se',
  's',
  'sw',
  'w',
  'nw',
]

export function resizeBugReportPopup(
  origin: PopupLayout,
  direction: ResizeDirection,
  deltaX: number,
  deltaY: number,
  bounds: {
    width: number
    height: number
    margin: number
    minWidth: number
    minHeight: number
  }
): PopupLayout {
  let { left, top } = origin
  let right = left + origin.width
  let bottom = top + origin.height
  const minWidth = Math.min(bounds.minWidth, bounds.width - bounds.margin * 2)
  const minHeight = Math.min(
    bounds.minHeight,
    bounds.height - bounds.margin * 2
  )

  if (direction.includes('w')) {
    left = Math.max(bounds.margin, Math.min(left + deltaX, right - minWidth))
  }
  if (direction.includes('e')) {
    right = Math.min(
      bounds.width - bounds.margin,
      Math.max(right + deltaX, left + minWidth)
    )
  }
  if (direction.includes('n')) {
    top = Math.max(bounds.margin, Math.min(top + deltaY, bottom - minHeight))
  }
  if (direction.includes('s')) {
    bottom = Math.min(
      bounds.height - bounds.margin,
      Math.max(bottom + deltaY, top + minHeight)
    )
  }

  return { left, top, width: right - left, height: bottom - top }
}
